<div *ngIf="request.canChangeFundingSource">
  <div class="p-grid">
    <div class="p-col-12 p-md-4 p-lg-4">
      <label> Select Funding Source</label>
    </div>
    <div class="p-col-12 p-md-8 p-lg-8">
      <p-dropdown [placeholder]="Validation.DropdownPlaceholder" [showClear]="true"
                  [options]="achFundingDropDown" filter="true"
                  [(ngModel)]="selectedFundingSource"
                  (onChange)="onChangeFundingSource(selectedFundingSource)">
      </p-dropdown>
    </div>
  </div>

</div>

<div *ngIf="selectedFundingSource else noFundingSource" class="p-grid">
  <div class="p-col-12 p-md-4 p-lg-4">
    <label>Bank Name</label>
  </div>
  <div class="p-col-12 p-md-8 p-lg-8">
    {{selectedFundingSource.bankName}}
  </div>

  <div class="p-col-12 p-md-4 p-lg-4">
    <label>Routing Number</label>
  </div>
  <div class="p-col-12 p-md-8 p-lg-8">
    {{selectedFundingSource.routingNumber}}
  </div>

  <div class="p-col-12 p-md-4 p-lg-4">
    <label>Account Number</label>
  </div>
  <div class="p-col-12 p-md-8 p-lg-8">
    {{selectedFundingSource.accountNumber}}
  </div>
</div>

<ng-template #noFundingSource>
  <p>Funding Source not found For making {{request.paymentType | titleCase}} payments, please Add a funding source</p>
</ng-template>
